"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Link = exports.Label = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _react = _interopRequireDefault(require("react"));
var _ui = require("../../ui");
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Label = (0, _styledComponents.default)(_ui.P)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin: 0;\n  margin-right: 5px;\n  color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.tertiary;
});
exports.Label = Label;
var Link = _styledComponents.default.div.attrs(function (props) {
  return {
    children: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Label, null, props.label), /*#__PURE__*/_react.default.createElement(_ui.RouterLink, {
      id: props.id,
      to: props.to
    }, props.children))
  };
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  margin: 10px 0px;\n"])));
exports.Link = Link;